import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppLightModal from '@/components/AppLightModal.vue'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { utcDateTimeToLocal, utcDateTimeToDate } from '@/utils/dateTime'
import { findSchool, deleteSchool } from './gql'
import { SchoolModel } from '@/interfaces/school'
import { TypedGqlError } from '@/interfaces/error'
import AuthFilter from '@/mixins/auth-filter'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppLightModal
  }
})
export default class SchoolDialog extends mixins(AuthFilter) {
  schoolsLoading = true

  targetSchool: SchoolModel | null = null

  deleteDialog = {
    show: false,
    title: '删除学校',
    text: ''
  }

  utcDateTimeToLocal = utcDateTimeToLocal
  utcDateTimeToDate = utcDateTimeToDate

  mounted () {
    this.getAttachDealers()
  }

  // 添加goods
  addSchool () {
    this.$router.push({
      name: 'EditSchool',
      params: {
        type: 'new'
      }
    })
  }

  editSchool (item: any, type: string) {
    this.$router.push({
      name: 'EditSchool',
      params: {
        type: type,
        id: item.id,
        name: item.name
      }
    })
  }

  // 显示删除弹框
  deleteHandler (school: any) {
    this.targetSchool = school
    this.deleteDialog.text = `是否确定删除学校 “${school.name}” ?`
    this.deleteDialog.show = true
  }

  // 获取经销商
  async getAttachDealers () {
    try {
      // todo
    } catch (error) {
      const typedError = error as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 删除学校request
  async deleteSchoolById () {
    if (!this.targetSchool) {
      return
    }
    const { id } = this.targetSchool
    this.deleteDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteSchool,
        variables: {
          schoolId: id
        }
      })
      if (result) {
        showNotification({
          msg: '删除成功!',
          type: SnackType.Success
        })
      }
    } catch (error) {
      const typedError = error as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 获取school by id
  async getSchoolById (schoolId: number) {
    try {
      const result = await this.$apollo.query({
        query: findSchool,
        variables: {
          schoolId
        }
      })
      return result.data.findSchool
    } catch (error) {
      const typedError = error as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
